/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

import { Component } from '@angular/core';

import type { IconToken } from '@recruitee/user-interface';
import { IconComponent } from '@recruitee/user-interface';

@Component({
  imports: [IconComponent],
  selector: 'rt-priority-cell',
  template: `
    <rt-icon [name]="'flag'" [colorToken]="priority.iconColorToken" margin-right-small></rt-icon>
    <span>{{ priority.label }}</span>
  `,
  styleUrls: ['./priority-cell.component.less'],
  host: {
    '[class]': '"priority"',
  },
  inputs: PriorityCellComponent.NgInputs,
})
export class PriorityCellComponent {
  public static NgInputs = ['priority' as const];

  public priority: { iconColorToken: IconToken; label: string };
}
